import { execSQL, esc, num, bit } from './api';

const TABLE = 'dbo.payroll_bank_account';
const SP    = 'dbo.payroll_bank_account_sp';

// Joined to the employee so the list can show who each account belongs to.
export const fetchBankAccounts = () =>
  execSQL(`
    SELECT b.*,
           LTRIM(RTRIM(ISNULL(e.initial,'') + ' ' + ISNULL(e.firstName,'') + ' ' + ISNULL(e.surName,''))) AS empName
    FROM ${TABLE} b
    LEFT JOIN dbo.payroll_employee e ON e.emp_id = b.emp_id
    WHERE b.status != 'Deleted'
    ORDER BY CAST(b.emp_id AS INT), b.priority ASC
  `);

const values = (d) =>
  `@accountName=${esc(d.accountName)},@bank=${esc(d.bank)},@branch=${esc(d.branch)},` +
  `@accountNum=${esc(d.accountNum)},@bankCode=${esc(d.bankCode)},@branchCode=${esc(d.branchCode)},` +
  `@splitType=${esc(d.splitType)},@splitValue=${num(d.splitValue)},@isDefault=${bit(d.isDefault)}`;

export const createBankAccount = (d) =>
  execSQL(`EXEC ${SP} @action='INSERT',@emp_id=${esc(d.emp_id)},${values(d)}`);

export const updateBankAccount = (id, d) =>
  execSQL(`EXEC ${SP} @action='UPDATE',@id=${id},${values(d)}`);

export const deleteBankAccount = (id) =>
  execSQL(`EXEC ${SP} @action='DELETE',@id=${id}`);

/* Sampath bulk salary transfer file.
 * Column order and headers copied from the client's own
 * "SALARY FORMAT - June '2026.xls": NAME / ACCOUNT NO. / BANK / BRANCH / AMOUNT / ID
 * Only bank-paid staff appear — cash and cheque are handled separately.
 * AMOUNT is net pay plus the attendance allowance, which the client works
 * out separately for support staff and pays in the same transfer. */
export const fetchSalaryPaymentFile = (runMonth) =>
  execSQL(`
    SELECT ISNULL(b.accountName, d.empName) AS name,
           b.accountNum                     AS accountNo,
           b.bankCode                       AS bank,
           b.branchCode                     AS branch,
           (d.netPay + ISNULL(d.attendanceAllowance, 0)) AS amount,
           d.emp_id                         AS id
    FROM dbo.payroll_run_detail d
    INNER JOIN dbo.payroll_run r ON r.id = d.runId
    LEFT JOIN dbo.payroll_employee e ON e.emp_id = d.emp_id
    LEFT JOIN ${TABLE} b ON b.emp_id = d.emp_id AND b.isDefault = 1 AND b.status <> 'Deleted'
    WHERE d.runMonth = ${esc(runMonth)} AND r.status <> 'Deleted' AND d.netPay > 0
      AND ISNULL(e.paymentMode, 'Bank') = 'Bank'
    ORDER BY CAST(d.emp_id AS INT)
  `);

/* Staff paid outside the bank run — cash, or a cheque held pending clearance. */
export const fetchNonBankPayments = (runMonth) =>
  execSQL(`
    SELECT d.emp_id, d.empName, d.category,
           ISNULL(e.paymentMode, 'Bank')  AS paymentMode,
           CONVERT(varchar(10), e.dateOfResignation, 120) AS dateOfResignation,
           d.netPay,
           ISNULL(d.attendanceAllowance,0) AS attendanceAllowance,
           (d.netPay + ISNULL(d.attendanceAllowance,0)) AS totalPaid
    FROM dbo.payroll_run_detail d
    INNER JOIN dbo.payroll_run r ON r.id = d.runId
    LEFT JOIN dbo.payroll_employee e ON e.emp_id = d.emp_id
    WHERE d.runMonth = ${esc(runMonth)} AND r.status <> 'Deleted' AND d.netPay > 0
      AND ISNULL(e.paymentMode, 'Bank') <> 'Bank'
    ORDER BY ISNULL(e.paymentMode,'Bank'), CAST(d.emp_id AS INT)
  `);
